/* AQUAWELLA FAQ: one-open-at-a-time with native <details> semantics. */
(() => {
  const selector = '.aw4-faq__list details[data-aw4-accordion]';
  const animations = new WeakMap();
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setOpen(item, opening) {
    const oldAnimation = animations.get(item);
    if (oldAnimation) {
      oldAnimation.cancel();
      animations.delete(item);
    }
    const before = item.getBoundingClientRect().height;
    item.dataset.state = opening ? 'open' : 'closed';
    if (opening) item.open = true;

    if (reducedMotion() || !item.animate) {
      item.open = opening;
      item.style.removeProperty('height');
      item.style.removeProperty('overflow');
      return;
    }

    const finalHeight = opening ? item.scrollHeight : item.querySelector('summary').getBoundingClientRect().height;
    // Keep the contents mounted until the closing animation completes.
    item.style.height = `${before}px`;
    item.style.overflow = 'hidden';
    const anim = item.animate(
      [{ height: `${before}px` }, { height: `${finalHeight}px` }],
      { duration: opening ? 300 : 250, easing: 'cubic-bezier(.22,1,.36,1)' }
    );
    animations.set(item, anim);
    anim.onfinish = () => {
      if (animations.get(item) !== anim) return;
      if (!opening) item.open = false;
      item.style.removeProperty('height');
      item.style.removeProperty('overflow');
      animations.delete(item);
    };
    anim.oncancel = () => {
      if (animations.get(item) === anim) animations.delete(item);
    };
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.aw4-faq__list details[data-aw4-accordion] > summary');
    if (!summary) return;
    const item = summary.parentElement;
    if (!item) return;
    event.preventDefault();
    const group = item.closest('.aw4-faq__list');
    const opening = item.dataset.state ? item.dataset.state !== 'open' : !item.open;
    if (opening && group) {
      group.querySelectorAll('details[data-aw4-accordion]').forEach(other => {
        if (other !== item && (other.open || other.dataset.state === 'open')) setOpen(other, false);
      });
    }
    setOpen(item, opening);
  });
})();
